var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup32928(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.988,
    height: 16.66,
    viewBox: "0 0 27.988 16.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32928",
    "data-name": "Group 32928",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video",
    "data-name": "Icon awesome-video",
    d: "M16.336,4.5H2.323A2.209,2.209,0,0,0,0,6.574V19.086A2.209,2.209,0,0,0,2.323,21.16H16.336a2.209,2.209,0,0,0,2.323-2.074V6.574A2.209,2.209,0,0,0,16.336,4.5Zm9.2,1.636-5.325,3.28v6.829l5.325,3.276A1.577,1.577,0,0,0,27.988,18.4V7.255A1.577,1.577,0,0,0,25.539,6.136Z",
    transform: "translate(0.001 -4.5)",
    fill: "#0267c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup32928);
export default __webpack_public_path__ + "static/media/Group 32928.196af808e0940e233d01b011050e3111.svg";
export { ForwardRef as ReactComponent };